import React from "react";

import { Section, TitleH1 } from "../../styles/sharedStyles";
import {
  Container,
  MainText,
  SubTitle,
  Ul
} from "../Policy/styles";

export const NotificationConsent = () => {
  return (
    <Section>
      <Container>
        <TitleH1>СОГЛАСИЕ НА ПОЛУЧЕНИЕ РАССЫЛКИ (ЭЛЕКТРОННЫХ СООБЩЕНИЙ)</TitleH1>
        <SubTitle>1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</SubTitle>
        <MainText>
          <strong>Согласие на получение рассылки (электронных сообщений)</strong> – документ, являющийся основанием для направления Оператором материалов рекламного и (или) информационного характера.<br/>
          <strong>Оператор – Индивидуальный предприниматель Прохорова Любовь Васильевна</strong> (ИНН 231130103902, ОГРНИП 321237500416095).<br/>
          <strong>Пользователь</strong> – любой посетитель сайта, который отправил заявку / заполнил лид-форму или иным образом оставил свои персональные данные при использовании сайта с доменным именем: https://prohorovaconsult.com/, в том числе всех его страниц и поддоменов, а также интегрированных с данными сайтами сервисов (чат-ботов, страниц сайтов платёжных сервисов и т.п.).<br/>
          <strong>Политика в отношении обработки персональных данных</strong> – документ, на основании которого пользователь дает свое согласие на получение рассылки (электронных сообщений), размещённая Оператором в сети Интернет по адресу: https://prohorovaconsult.com/policy.
        </MainText>
        <SubTitle>2. ОБЩИЕ ПОЛОЖЕНИЯ</SubTitle>
        <MainText>
          <Ul>
            <li>1. Настоящее Согласие на получение рассылку (электронных сообщений) (далее – <strong>«Согласие»</strong>) является основанием для направления Пользователю информационных и(или) рекламных сообщений от Оператора по электронной почте, посредством мессенджеров, ботов, а также иными способами.</li>
            <li>2. Пользователь, дает Согласие на получение рассылки электронных сообщений, которое действует с момента предоставления такого согласия.</li>
            <li>3. Пользователь подтверждает, что действует по своей воле и в своём интересе.
            </li>
            <li>4. Настоящее Согласие является конкретным, информированным и сознательным.
            </li>
            <li>5. Пользователь, пользуясь и (или) вводя свои персональные данные, в ходе заполнения формы на сайте, даёт своё согласие на получение рассылки материалов рекламного и(или) информационного характера посредством sms-серверов, электронной почты, мессенджеров и социальных сетей от Оператора и подтверждает, что ознакомлен с условиями Политики в отношении обработки персональных данных, в продолжение чего дает Согласие на обработку персональных данных в целях получения рассылки (электронных сообщений) с рекламными и(или) информационными материалами.
            </li>
          </Ul>
        </MainText>
        <SubTitle>3. ПЕРСОНАЛЬНЫЕ ДАННЫЕ, ПРЕДОСТАВЛЯЕМЫЕ ПОЛЬЗОВАТЕЛЕМ В ЦЕЛЯХ ПОЛУЧЕНИЯ РЕКЛАМНОЙ И(ИЛИ) ИНФОРМАЦИОННОЙ РАССЫЛКИ
        </SubTitle>
        <MainText>
          Пользователь в целях получения рассылки электронных сообщений предоставляет Оператору следующие персональные данные (в случае, если они предусмотрены чекбоксом на сайте, «кнопками» в боте или иным образом собираются от Пользователя Оператором): имя, фамилия, отчество, никнейм и ID в мессенджере, адрес электронной почты, контактный номер телефона.
        </MainText>
        <SubTitle>4. СРОК ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ, АКТУАЛИЗАЦИЯ И ОТЗЫВ СОГЛАСИЯ НА РАССЫЛКУ ЭЛЕКТРОННЫХ СООБЩЕНИЙ
        </SubTitle>
        <MainText>
          <Ul>
            <li>1. Пользователь ознакомлен с информацией о том, что в любой момент в течение всего срока действия настоящего Согласия, вправе отозвать согласие на получение рассылки (электронных сообщений) путём направления соответствующего запроса на электронную почту Исполнителя: prohorovaconsult@yandex.ru.</li>
            <li>2. Пользователь, дает Согласие на получение рассылки электронных сообщений, которая действует со дачи согласия и до получения отзыва указанного согласия Оператором, но не дольше предельных сроков обработки персональных данных, установленных законодательством Российской Федерации.</li>
          </Ul>
        </MainText>
      </Container>

    </Section>
  );
};

